import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Stack, Typography } from '@mui/material';

import { useGetAccount } from '~/hooks/apis/offers/useGetAccount';

import AccountAssetsCard from './AccountAssetsCard';
import AccountCasesCard from './AccountCases/AccountCasesCard';
import AccountOpportunitiesCard from './AccountOpportunitiesCard';
import AccountTabs from './AccountTabs';
import AccountContactsCard from './Contacts/AccountContactsCard';
import AccountExpensesCard from './Expenses/AccountExpensesCard';
import AccountNotesAttachmentsCard from './NotesAttachments/AccountNotesAttachmentsCard';
import AccountRelatedContactsCard from './RelatedContacts/AccountRelatedContactsCard';

export default function AccountRelatedPage() {
  const { id_account: accountId } = useParams<{ id_account: string }>();
  const { data: account } = useGetAccount(accountId);

  return (
    <>
      <Helmet>
        <title>Related | {account?.name || accountId}</title>
      </Helmet>

      <AccountTabs accountId={accountId} activeTab="related" />

      <Typography variant="h4" sx={{ mb: 1 }}>
        Related
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Records linked to this Salesforce Account.
      </Typography>

      <Stack spacing={3}>
        <AccountOpportunitiesCard accountId={accountId} />
        <AccountContactsCard accountId={accountId} />
        <AccountAssetsCard accountId={accountId} />
        <AccountNotesAttachmentsCard accountId={accountId} />
        <AccountCasesCard accountId={accountId} />
        <AccountExpensesCard accountId={accountId} />
        <AccountRelatedContactsCard accountId={accountId} />
      </Stack>
    </>
  );
}
